module.exports = __webpack_public_path__ + "static/media/Rope-Clamp.46dbaa2a.jpg";